import { NotificationsRes, Type } from '@/api/types/notificationsType';
import { ColumnType } from '@/types';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import { getNotificationMessage } from '@/utils/getNotificationMessage';

const TYPE_COLORS: Partial<Record<Type, string>> = {
  [Type.REQUEST_SUBMISSION]: 'blue',
  [Type.REQUEST_ASSIGNED]: 'geekblue',
  [Type.REQUEST_APPROVAL]: 'green',
  [Type.REQUEST_REJECTED]: 'red',
  [Type.CHANGE_REQUEST]: 'orange',
  [Type.CHANGE_REQUEST_RESOLVED]: 'cyan',
  [Type.UserRegistration]: 'purple',
  [Type.POST_PUBLICATION]: 'geekblue',
  [Type.ADMIN_CREATED]: 'gold',
  [Type.ADMIN_UPDATED]: 'gold',
  [Type.USER_CREATED]: 'purple',
  [Type.USER_DISABLED]: 'red',
  [Type.ROLE_ASSIGNED]: 'magenta',
  [Type.ROLE_PERMISSION_ASSIGNED]: 'volcano',
};

export const getColumns = (
  translate: (key: string, options?: Record<string, string | number>) => string
): ColumnType[] => [
  {
    title: translate('notifications.columns.message'),
    dataIndex: 'body',
    key: 'body',
    render: (_: string, record: NotificationsRes) => (
      <div
        className={
          record.is_read
            ? 'text-slate-500 dark:text-slate-300'
            : 'font-medium text-slate-900 dark:text-white'
        }
      >
        <div>{getNotificationMessage(translate, record)}</div>
        {record.translation_params?.user_email && (
          <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
            {String(record.translation_params.user_email)}
          </div>
        )}
      </div>
    ),
  },
  {
    title: translate('notifications.columns.type'),
    dataIndex: 'type',
    key: 'type',
    render: (type: Type) => (
      <Tag color={TYPE_COLORS[type] ?? 'default'}>
        {translate(`notifications.type.${type}`)}
      </Tag>
    ),
  },
  {
    title: translate('notifications.columns.details'),
    dataIndex: 'translation_params',
    key: 'details',
    render: (params: NotificationsRes['translation_params']) => {
      if (!params?.request_type) {
        return '—';
      }

      return (
        <div className="text-sm">
          <div>{translate(`listing-request.type.${params.request_type}`)}</div>
          {params.request_status && (
            <div className="text-xs text-gray-600 dark:text-gray-400">
              {translate(`listing-request.status.${params.request_status}`)}
            </div>
          )}
        </div>
      );
    },
  },
  {
    title: translate('notifications.columns.date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date: string) => dayjs(date).format('YYYY-MM-DD HH:mm'),
  },
  {
    title: translate('notifications.columns.status'),
    dataIndex: 'is_read',
    key: 'is_read',
    render: (isRead: boolean) => (
      <Tag color={isRead ? 'default' : 'processing'}>
        {translate(
          isRead ? 'notifications.status.read' : 'notifications.status.unread'
        )}
      </Tag>
    ),
  },
];
